/** @format */

const questions = [
  {
    id: 0,
    question: '¿Quién puede tomar este plan?',
    answer: (
      <div>
        Cualquier persona mayor de 15 años desde cualquier parte del
        mundo que cuente con los requisitos mínimos en su equipo de
        computo.
      </div>
    ),
  },
  {
    id: 1,
    question: '¿Cómo es la metodología de las clases?',
    answer: (
      <div>
        Serán clases en vídeo a través de nuestra plataforma (16
        cursos) y podrás ver cada curso a tu ritmo.
        <br />
        Este plan NO cuenta con feedback en vivo por Zoom semanal ni
        Discord privado. Revisa nuestro módulo "Método de estudio"
        para ampliar la información.
      </div>
    ),
  },
  {
    id: 2,
    question: '¿Por qué elegir a Libel Academy?',
    answer: (
      <ul>
        <li>
          Tenemos un método de estudio controlado para aprender desde
          cero y en corto tiempo, donde el estudiante recibe todo el
          contenido en los tiempos estipulados, adicionalmente,
          entregamos material de diferentes niveles para que su
          proceso de aprendizaje no se detenga.
        </li>
        <li>
          Nuestros docentes son especialistas en cada una de sus áreas
          (no son generalistas).
        </li>
        <li>
          Los resultados de nuestros estudiantes son realmente
          sorprendentes.
        </li>
        <li>
          Puedes revisar todos nuestros beneficios en nuestra home.
        </li>
      </ul>
    ),
  },
  {
    id: 4,
    question: '¿Qué conocimientos tendré al finalizar?',
    answer: (
      <div>
        Podrás crear modelos inorgánicos y personajes de nivel
        básico-intermedio en Blender para videojuegos y para
        animación, de modo que estarás listo(a) para un reto de mayor
        nivel.
      </div>
    ),
  },
  {
    id: 5,
    question: '¿La renovación del plan es automática?',
    answer: (
      <div>
        Este es un plan mensual que te permite acceder a los 16 cursos
        mostrados. Debes renovar el plan cada mes para continuar
        accediendo. No tenemos renovaciones automáticas ni cláusulas
        de permanencia .
      </div>
    ),
  },
  {
    id: 6,
    question: '¿Puedo retirarme cuando quiera?',
    answer: (
      <div>
        Debes renovar el plan cada mes para continuar accediendo. No
        tenemos renovaciones automáticas ni cláusulas de permanencia ,
        así que puedes decidir no continuar en cualquier momento.
      </div>
    ),
  },
  {
    id: 7,
    question: '¿Cuál es el calendario de clases?',
    answer: (
      <div>
        En Discord encontrarás un calendario con los días y horas de
        los feedback en vivo. Generalmente se realizan los domingos
        entre las 8:00 y las 10:00 pm, hora Colombia.
      </div>
    ),
  },
];

export default questions;
